import { AuthService } from '$services/auth/auth.service';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-signup-finish',
  templateUrl: './signup-finish.component.html',
  styleUrls: ['./signup-finish.component.css']
})
export class SignupFinishPageComponent {
  success: boolean = false;
  error: boolean = false;

  constructor(private readonly authService: AuthService, private route: ActivatedRoute) { }

  ngOnInit(): void {

    const token = this.route.snapshot.paramMap.get('token')!,
      mail = this.route.snapshot.queryParamMap.get('mail')!

    this.processSignupFinish(token, mail)

  }
  processSignupFinish(token: string, mail: string) {
    this.authService.signupFinish(token, mail).subscribe({
      next: data => {

        this.showSuccessRegister()

      },
      error: err => {
        console.error(err)
        this.error = true
      }
    })
  }
  showSuccessRegister() {
    this.success = true
  }
}
